import { clsx } from 'clsx';

type SpinnerProps = { className?: string };

export function Spinner({ className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Lade"
      className={clsx(
        'inline-block h-5 w-5 animate-spin rounded-full border-2 border-ink-faint border-t-teal',
        className
      )}
    />
  );
}
